import React from 'react';

import ReferencePickerPlugin from '../../../../types/ReferencePickerPlugin';
import { useTranslation } from '../../i18n';
import { SubmittalsItem } from '../../types';

const RemoveReferenceModalContent: ReferencePickerPlugin<SubmittalsItem>['CustomRemoveEntityModalContent'] =
  () => {
    const { t } = useTranslation();

    return <span>{t('REMOVE_REFERENCE_CONFIRMATION_TEXT')}</span>;
  };

export default RemoveReferenceModalContent;
